import { CountUp } from 'countup.js';

export default function countUp() {
    const countUps = document.querySelectorAll('.countup');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const options = {
                separator: '.',
                decimal: ',',
            };
            if (entry.intersectionRatio > 0) {
                let { number } = entry.target.dataset;
                const { decimals } = entry.target.dataset;
                if (decimals) {
                    options.decimalPlaces = decimals.length;
                    number = `${number}.${decimals}`;
                }
                const count = new CountUp(entry.target, number, options);
                count.start();
                observer.unobserve(entry.target);
            }
        });
    });

    countUps.forEach((image) => {
        observer.observe(image);
    });
}
